// extracted by mini-css-extract-plugin
module.exports = {"container":"ABgMTaDuUFGMkBqVxnF9a"};